<template>
  <div>
    <slot/>
  </div>
</template>

<script>
export default {
  name: "lms-query-params",
  mounted() {
    this.persistentParams();
  },
  methods: {
    // Check if there are any url parameters
    // if so, validate and save to session storage
    // attempt to append them to each href every page load
    persistentParams() {

      // Check if we already set the incoming parameters for this session
      var paramsStored = this.getSessionTrackingParams();

      // If no Session Storage, check for url parameters
      if (!paramsStored) {

        const urlParams = this.getURLParams();
        
        if(urlParams.length === 0 || !urlParams) {
          // If there are not tracking parameters
          // Other params in this session will be assumed for functionality and ignored
          this.setSessionTrackingParams("notracking");
        }else {
          // validate then set
          const validParams = this.validateParams(urlParams);
          this.setSessionTrackingParams(validParams);
          this.appendParameters(validParams);
        }

      } else if (paramsStored !== "notracking") {
        // Params have been stored and exist
        // Append to urls
        this.appendParameters(paramsStored);
      }
    },
    getSessionTrackingParams() {
      var setParams = sessionStorage.getItem("LMSTrackingParms");
      
      return setParams;
    },
    setSessionTrackingParams(params) {
      if(params) {
        sessionStorage.setItem("LMSTrackingParms", params);
      }
    },
    clearSessionTrackingParams() {
      sessionStorage.removeItem("LMSTrackingParms");
    },
    getURLParams() {
      const paramString = window.location.search;

      return paramString;
    },
    validateParams(preParams) {

      const allowedParams = [
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_content",
        "trkid",
        "packid",
        "gclid",
        "dclid"
      ];

      var validParamString = '?';
      const urlParams = new URLSearchParams(preParams);
      const params = Object.fromEntries(urlParams.entries());

      for (const [key, value] of Object.entries(params)) {

        if(allowedParams.includes(key)) {
          
          validParamString += ( key + "=" + value + "&");

        }
      }

      return validParamString;
    },
    // Add the safe parameters too all the urls on the page
    appendParameters( paramsToAdd ) {
      var l = document.links;
      for(var i=0; i<l.length; i++) {

        var alink = l[i].href;

        // Append stored params
        // Skip wp-admin links
        if(!alink.includes('wp-admin')){
          l[i].href = l[i].href + paramsToAdd;
        }
      }
    }
  },
};
</script>
